export const userPositions = {
  GeneralManager: 'GeneralManager',
  Accounting: 'Accounting',
  FrontDesk: 'FrontDesk',
  HouseKeeping: 'HouseKeeping',
  AGM: 'AGM',
  Corporate: 'Corporate',
  DOS: 'DOS',
  Unknown: 'Unknown'
}

export const userPositionNames = {
  Corporate: 'Corporate',
  GeneralManager: 'GM',
  AGM: 'AGM',
  DOS: 'DOS',
  FrontDesk: 'front desk',
  Accounting: 'accounting',
  Housekeeping: 'housekeeping',
  Unknown: 'hotel staff'
}
